module.exports = __webpack_public_path__ + "static/media/peristyl_tn.9c5f6f2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/peristyl_tn.jpg
// module id = 776
// module chunks = 0